import { render, staticRenderFns } from "./OrderSupplierFee.vue?vue&type=template&id=6161f70e"
import script from "./OrderSupplierFee.vue?vue&type=script&lang=js"
export * from "./OrderSupplierFee.vue?vue&type=script&lang=js"
import style0 from "./OrderSupplierFee.vue?vue&type=style&index=0&id=6161f70e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports